module.exports = __webpack_public_path__ + "static/img/utsntb.d947ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/utsntb.png
// module id = g3gV
// module chunks = 15